import _sfc_main from "./PanelContainer.vue2.mjs";
/* empty css                     */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", [_setup.panelVisible && _setup.isMobile ? _c("div", { staticClass: "panel-container h5" }, [_c("div", { staticClass: "container-header" }, [_c(_setup.SvgIcon, { staticClass: "container-header-back", attrs: { "icon": _setup.ArrowStrokeBackIcon }, on: { "click": _setup.closePanel } }), _c("span", { staticClass: "container-header-title" }, [_vm._v(" " + _vm._s(_setup.props.title) + " ")]), !_vm.$slots.edit ? [_vm._t("edit"), _c("span", { staticClass: "container-header-edit", on: { "click": _setup.handleEdit } }, [_vm._v(" " + _vm._s(_setup.props.editButtonText || "") + " ")])] : _vm._e()], 2), _c("div", { staticClass: "container-content" }, [_vm._t("default")], 2), _vm._t("footer")], 2) : _vm._e(), !_setup.isMobile ? _c(_setup.TuiDialog, { attrs: { "title": _vm.title, "modal": true, "append-to-body": true, "width": _vm.width }, scopedSlots: _vm._u([_vm.$slots.footer ? { key: "footer", fn: function() {
    return [_vm._t("footer")];
  }, proxy: true } : null], null, true), model: { value: _setup.panelVisible, callback: function($$v) {
    _setup.panelVisible = $$v;
  }, expression: "panelVisible" } }, [_vm._t("default")], 2) : _vm._e()], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "de9803a2"
);
const PanelContainer = __component__.exports;
export {
  PanelContainer as default
};
